export default __webpack_public_path__ + "static/media/chandrashan_perera.96c84cae.jpg";